<template>
    <!--
        Barras de señal de la conexión del puesto, visibles siempre.
        Antes solo aparecía un aviso cuando algo iba mal, y un indicador que
        únicamente se asoma en la falla nadie sabe interpretarlo cuando por fin
        aparece. Estando siempre, la gente aprende a leerlo — y ante una queja de
        lentitud basta preguntar "¿cómo están las barras?" para saber de qué lado
        está el problema.
        El texto solo se muestra cuando la conexión está mala: el usuario final
        no es técnico y no necesita leer nada mientras todo funcione.
    -->
    <div class="d-flex align-items-center mr-3" :title="titulo">
        <span class="d-inline-flex align-items-end mr-1" style="height: 14px;">
            <i v-for="n in 4" :key="n"
               class="d-inline-block rounded-sm"
               :class="n <= (nivel || 0) ? color : 'bg-secondary'"
               :style="estiloBarra(n)"></i>
        </span>
        <span v-if="nivel === 1" class="small font-weight-bold text-danger d-none d-md-inline">
            Conexión inestable
        </span>
    </div>
</template>

<script>
import { estado } from "../../monitoring/calidadConexion";

/** Alto de cada barra, para que crezcan de izquierda a derecha. */
const ALTOS = [4, 7, 10, 13];

export default {
    name: "IndicadorConexion",

    computed: {
        nivel() {
            return estado.nivel;
        },

        color() {
            if (this.nivel === null) return 'bg-secondary';
            if (this.nivel <= 1) return 'bg-danger';
            if (this.nivel === 2) return 'bg-warning';
            return 'bg-success';
        },

        /** Frase en palabras, sin cifras: el detalle vive en los logs. */
        titulo() {
            return {
                null: 'Midiendo la conexión…',
                1: 'La conexión de este equipo está presentando intermitencias',
                2: 'La conexión de este equipo está regular',
                3: 'Conexión estable',
                4: 'Conexión estable',
            }[this.nivel === null ? 'null' : this.nivel];
        },
    },

    methods: {
        estiloBarra(n) {
            // Las barras sin alcanzar quedan tenues en vez de desaparecer, para
            // que el indicador no cambie de tamaño al variar el nivel.
            return {
                width: '3px',
                height: ALTOS[n - 1] + 'px',
                marginRight: n < 4 ? '2px' : '0',
                opacity: n <= (this.nivel || 0) ? '1' : '0.25',
            };
        },
    },
};
</script>
